<template>
  <div>
    <ReceiptViewer
      :showDialog="showDialog"
      v-on:hide="receiptViewerOnHide"
      v-on:closeAutoPilot="closeAutoPilot"
      :receiptImage="receiptImageElement"
      :receiptImageIsLoading="receiptImageIsLoading"
    />
    <v-data-table
      :headers="headers"
      :items="payments"
      :items-per-page="5"
      class="elevation-1"
      @click:row="handleClick"
    >
    </v-data-table>

    <v-data-table
      :headers="headers_2"
      :items="refs"
      :items-per-page="5"
      class="elevation-1"
      @click:row="searchReferenceNumber"
    ></v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";

import ReceiptViewer from "../components/ReceiptViewer";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    ReceiptViewer,
  },
  computed: {
    ...mapGetters([
      "userToken",
      "allReceipts",
      "selectedDashboard",
      "userRoles",
      "isTester",
    ]),
     ...mapFields([
      "reClaimed",
      "reClaimText",
      "referenceNumber",
      "receiptImageURL",
      "createdAt",
      "createdAtDate",
      "createdAtTime",
      "status",
      "id",
      "campaignTitle",
      "campaign_fk",
      "receiptNumber",
      "total",
      "campaignRetailers",
      "hasWallet",
      "products",
      "couponsToCreate",
      "hasEditableCoupons",
      "productImageURL",
      "detailsText",
      "campaignEndDate",
      "campaignStartDate",
      "processedProducts",
      "productTotal",
      "retailerFk",
      "customerToken",
      "selectedProducts",
      "receiptDateTime",
      "orderId",
      "sendSftp",
      "receiptId",
      "fraud",
      "selectedCheckbox",
      "country",
      "clubCode",
      "fiscalId",
      "rppData"
    ]),
  },
  data: () => ({
    showDialog: false,
    receiptImageElement: new Image(),
    headers: [
      {
        text: "Number of payments",
        align: "start",
        sortable: true,
        value: "paymentCount",
      },
      { text: "Payment Amount", value: "amount" },
    ],
    headers_2: [
      {
        text: "ReferenceNumber",
        value: "referenceNumber",
      },
      {
        text: "Created At",
        value: "createdAt",
      },
      {
        text: "Sftp Sent",
        value: "sendSftp",
      },
      {
        text: "Sftp File",
        value: "sftpFile",
      },
      {
        text: "Payment Amount",
        value: "paymentAmount",
      },
    ],
    payments: [],
    refs: [],
    rawData: {},
  }),
  mounted() {
    axios
      .post("http://127.0.0.1:3000/api/dashboard/paymentAmountCheck", {
        sessid: this.userToken,
        campaignId: "lenor-pm",
      })
      .then((res) => {
        if (res.data.response) {
          this.rawData = res.data.categories;
          let values = Object.keys(res.data.categories);
          let labels = Object.values(res.data.categories);
          values.forEach((v, idx) => {
            this.payments.push({
              paymentCount: labels[idx].length,
              amount: v,
            });
          });
        }
      });
  },
  methods: {
    ...mapActions([
      "getAllReceipts",
      "getOneReceipt",
      "dropReceipt",
      "setReceiptModalState",
      "getReceiptWithId",
      "getPerformance",
      "getDashboardData",
      "getProductsList",
      "getReceiptwithRefNumber",
    ]),
    handleClick(e) {
      console.log(e.paymentCount, this.rawData[e.amount]);
      this.refs = [];
      const refs = this.rawData[e.amount];
      refs.forEach((ref) => {
        this.refs.push({
          referenceNumber: ref.referenceNumber,
          createdAt: ref.createdAt,
          sendSftp: ref.sendSftp,
          sftpFile: ref.sftpFile,
        });
      });
    },
    closeAutoPilot() {
      console.log("AutoPilot is closed");
      this.counting = false;
      this.autoPilotSwitch = false;
    },
    receiptViewerOnHide(autoPilot) {
      this.showDialog = false;
      this.autoPilotSwitch = autoPilot;
      this.countDown = 100;
    },
    searchReferenceNumber(e) {
      console.log(this.selectedDashboard);
      this.getReceiptwithRefNumber({
        userToken: this.userToken,
        referenceNumber: e.referenceNumber,
        dashboard: this.selectedDashboard,
      }).then((res) => {
        {
          const receipt = res.receipt;
          const products = res.campaignProducts;
          if (this.selectedDashboard.isCroppable) {
            this.receiptImageURL = receipt.receiptFullImageURL;
          } else {
            this.receiptImageURL = receipt.receiptImageURL;
          }
          this.productImageURL = receipt.productImageURL;

          const payload = {
            userToken: this.userToken,
            dashboard: this.selectedDashboard,
            campaign_fk: receipt.campaign_fk,
          };

          this.getDashboardData(payload);
          this.img = new Image();
          this.receiptImageIsLoading = true;
          this.img.onload = () => {
            this.paymentAmount = receipt.paymentAmount;
            this.receiptImageIsLoading = false;
            this.receiptImageElement = this.img;
          };

          this.country = receipt.country;
          this.img.src = `${this.receiptImageURL}?${new Date().getTime()}`;
          this.createdAt = receipt.createdAt;
          this.campaignTitle = receipt.campaignTitle;
          this.campaign_fk = receipt.campaign_fk;
          this.fraud = receipt.fraud;
          this.receiptDateTime = receipt.receiptDateTime;
          this.createdAtTime = moment(receipt.updatedAt).format("HH:MM");
          this.createdAtDate = receipt.updatedAt;
          this.status = receipt.status;
          this.id = receipt.receiptToken;
          this.customerToken = receipt.customerToken;
          this.referenceNumber = receipt.referenceNumber;
          this.receiptNumber = receipt.identifiedId;
          this.total = receipt.total;
          this.couponsToCreate = receipt.couponsPerReceipt;
          this.detailsText = receipt.detailsText;
          this.receiptId = receipt.receiptId;
          this.retailerFk =
            receipt.retailer == "15" ? "Not selected" : receipt.retailer;
          if (typeof this.retailerFk === "string") {
            this.retailerFk = parseInt(this.retailerFk);
          }
          this.campaign_fk = receipt.campaignId;
          this.fraud = receipt.fraud;
          this.rejectReason = receipt.rejectReason;
          this.paymentAmount = receipt.paymentAmount;
          if (receipt.clubCode) this.clubCode = receipt.clubCode;
          if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
          if (receipt.rppData) this.rppData = receipt.rppData;
          this.selectedCheckbox =
            receipt.extra && JSON.parse(receipt.extra).selectedCheckbox
              ? JSON.parse(receipt.extra).selectedCheckbox
              : {
                  vatMetro: { value: false, status: 0 },
                  rossmannDiscount: { value: false, status: 0 },
                };
          this.campaignEndDate = moment(receipt.campaignEndDate).format(
            "DD-MM-YYYY"
          );
          this.campaignStartDate = moment(receipt.campaignStartDate).format(
            "DD-MM-YYYY"
          );
          this.hasWallet = receipt.hasWallet;
          if (receipt.selectedProducts) {
            this.selectedProducts = JSON.parse(receipt.selectedProducts);
            console.log("PPPP", this.selectedProducts);
          }
          if (this.hasWallet) {
            const identifications = JSON.parse(receipt.identifications);

            if (identifications)
              this.productTotal = identifications.productTotal;
          }

          this.getProductsList({
            dashboard: this.selectedDashboard,
            campaignId: receipt.campaignId,
          }).then((products) => {
            if (products.length) {
              this.products = products;
              this.processedProducts = [];
              this.showDialog = true;
            } else if (this.selectedDashboard.campaignId === 'pg-ro') {
              this.products = products
              this.processedProducts = []
              this.showDialog = true
            }
          });

          if (this.couponsToCreate === -1) {
            this.hasEditableCoupons = true;
            this.couponsToCreate = 1;
          }
          this.campaignRetailers = res.campaignRetailers;

          if (receipt.hasWallet) {
            this.hasWallet = receipt.hasWallet;
          }
          if (res.campaignProducts) {
            this.products = res.campaignProducts;
            this.processedProducts = [];
            if (
              "processedProducts" in receipt &&
              receipt.processedProducts != null
            ) {
              const parsedSelecteds = JSON.parse(receipt.processedProducts);
              parsedSelecteds.forEach((selectedProduct) => {
                console.log("SELECTEd PPP", selectedProduct);
                const product = {
                  groupingId: selectedProduct.groupingId.split("$$")[1],
                  items: selectedProduct.items,
                  total: selectedProduct.total,
                };
                this.processedProducts.push(product);
                const foundProduct = this.products.find(
                  (e) => e.ean === product.groupingId
                );
                foundProduct.count = product.items;
              });
            }
          }
        }
      });
    },
  },
};
</script>
